import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';

/**
 * Scoped React Query provider for the /production/* subtree (D-01).
 *
 * The client is instantiated at module load (once) so remounting the route
 * does not throw away the cache. Retry guard returns false on 401 so the
 * axios interceptor in web/src/config/api.ts can redirect to /login without
 * React Query retrying the request (RESEARCH.md Risk #12).
 *
 * staleTime 30_000ms keeps production data cached for 30 seconds so the
 * operator views share fetched data rather than refetching per mount.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err: any) => err?.response?.status !== 401 && count < 1,
    },
    mutations: { retry: 0 },
  },
});

export default function ProductionProvider() {
  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
    </QueryClientProvider>
  );
}
